import * as Yup from 'yup'
import { currentMessageValidation } from '.'
import { maxFileSize, supportedImageFormats } from '../config'

Yup.setLocale(currentMessageValidation)

Yup.addMethod(Yup.mixed, 'isValidImage', function () {
    return this
        .notOneOf([null, ''], 'FORM_VALIDATION.REQUIRED')
        .test(
            'isValidImageSize',
            'FORM_VALIDATION.MAX_SIZE_IMAGE',
            (value) => typeof value === 'string' ? value : value.size <= maxFileSize
        )
        .test(
            'isValidImageType',
            'FORM_VALIDATION.UNSUPPORTED_FORMAT',
            (value) => typeof value === 'string' ? value : supportedImageFormats.includes(value.type)
        )
})

export default Yup
